import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AdminSearch from '../components/AdminSearch.js';

const AdminReservations = ({ activeTab }) => {
  const [reservations, setReservations] = useState([]);

  const fetchReservations = async () => {
    try {
      const res = await axios.get('/api/reservation/get/all/reservations');
      setReservations(res.data);
    } catch (err) {
      console.error('Error fetching reservations:', err);
    }
  };

  useEffect(() => {
    if (activeTab === 'reservations') {
      fetchReservations();
    }
  }, [activeTab]);

  const handleStatusChange = async (reservationId, currentStatus) => {
    const { value: newStatus } = await Swal.fire({
      title: "Promijeni status rezervacije",
      input: "select",
      inputOptions: {
        1: "na cekanju",
        2: "otkazano",
        3: "potvrdjeno",
        4: "odrzano"
      },
      inputValue: currentStatus,
      showCancelButton: true,
      icon: 'warning',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: "Sačuvaj",
      cancelButtonText: "Odustani",
    });

    if (newStatus) {
      try {
        await axios.put(`/api/reservation/update/admin/${reservationId}`, { status: newStatus });
        Swal.fire("Uspjeh!", "Status je uspješno izmijenjen.", "success");
        fetchReservations();
      } catch (error) {
        Swal.fire("Greška!", "Došlo je do greške pri izmjeni statusa.", "error");
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDate2 = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <div>
      <p>Pregled rezervisanih termina</p>
    
      <AdminSearch/>
    
      <table>
        <thead>
          <tr>
            <th>ID Profesora</th>
            <th>Profesor</th>
            <th>ID Ucenika</th>
            <th>Učenik</th>
            <th>Predmet</th>
            <th>Nivo</th>
            <th>Datum</th>
            <th>Dan</th>
            <th>Sat</th>
            <th>Status</th>
            <th>Vrijeme zakazivanja</th>
            <th>Razlog otkazivanja</th>
          </tr>
        </thead>
        <tbody style={{ color: 'white' }}>
          {reservations.map((reservation) => (
            <tr key={reservation.id} style={{
              backgroundColor: reservation.status === 1 ? 'grey' :
                reservation.status === 2 ? '#dc3545' :
                  reservation.status === 3 ? '#28a745' :
                    reservation.status === 4 ? '#0056b3' : 'white'
            }}>

              <td>{reservation.id_profesora}</td>
              <td>{reservation.ime_profesora}</td>
              <td>{reservation.id_ucenika}</td>
              <td>{reservation.ime_ucenika}</td>
              <td>{reservation.predmet}</td>
              <td>{reservation.nivo}</td>
              <td>{formatDate(reservation.datum)}</td>
              <td>{reservation.dan}</td>
              <td>{reservation.sat}</td>
              <td onClick={() => handleStatusChange(reservation.id, reservation.status)} style={{ cursor: "pointer" }}>{reservation.ime_statusa}</td>
              <td>{formatDate2(reservation.vrijeme_zakazivanja)}</td>
              <td>{reservation.RAZLOG}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminReservations;